/** Exposes the runtime configuration that the Zendesk app needs to talk to Linear and OAuth endpoints. */
export class Config {
  /** Whether the app is running in production mode. */
  public static PROD = import.meta.env.PROD;
  /** Base URL of the Linear web client. */
  public static CLIENT_URL = import.meta.env.VITE_CLIENT_URL;
  /** URL of the Linear GraphQL API. */
  public static GRAPHQL_URL = import.meta.env.VITE_GRAPHQL_URL;

  /** OAuth authorization endpoint URL. */
  public static OAUTH_URL = import.meta.env.VITE_OAUTH_URL;
  /** OAuth client identifier. */
  public static OAUTH_CLIENT_ID = import.meta.env.VITE_OAUTH_CLIENT_ID;
  /** OAuth redirect URI after authorization. */
  public static OAUTH_REDIRECT_URI = import.meta.env.VITE_OAUTH_REDIRECT_URI;
  /** OAuth token exchange endpoint URL. */
  public static OAUTH_TOKEN_URL = import.meta.env.VITE_OAUTH_TOKEN_URL;
}
